export default __webpack_public_path__ + "static/media/screen3.6d4d4d8c.png";